/**
 * Phone/mobile input rules — a mobile number is exactly 10 digits.
 * Use `sanitizePhone` on every phone input's onChange, and `isValidPhone`
 * to block submission until a full 10-digit number is entered.
 */

/** Keep digits only, capped at 10 — so the user can type at most a 10-digit number. */
export function sanitizePhone(v: string): string {
  return v.replace(/\D/g, "").slice(0, 10);
}

/** A phone number is valid only when it is exactly 10 digits. */
export function isValidPhone(v: string | null | undefined): boolean {
  return /^\d{10}$/.test((v ?? "").trim());
}

/** Shared HTML attributes for a 10-digit phone input. Spread onto the <input>. */
export const PHONE_INPUT_PROPS = {
  type: "tel" as const,
  inputMode: "numeric" as const,
  pattern: "\\d{10}",
  maxLength: 10,
  placeholder: "10-digit mobile number",
};
